import { render } from "./delete-prompt.vue?vue&type=template&id=3b6ac35a&lang=pug"
import script from "./delete-prompt.vue?vue&type=script&lang=js"
export * from "./delete-prompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__